<script>
  import { Tooltip } from "@urbaninstitute/dataviz-components";
  let { x, y, state, name, active_seg_label, active_seg_value, extra_label, extra_value } =
    $props();

  // Round numeric values to the nearest hundredth; pass category labels through unchanged.
  function fmt(v) {
    if (v === null || v === undefined || v === "") return v;
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(2) : v;
  }
</script>

{#if x && y}
  <Tooltip {x} {y} size="large">
    <div class="tooltip-content">
      <p class="tooltip-heading"><span class="state-label">{state}</span></p>
      <p class="tooltip-heading">{name}</p>
      <div class="table">
        <p class="value"><span class="value-highlight">{fmt(active_seg_value)}</span></p>
        <p class="label">{active_seg_label}</p>
      </div>
      {#if extra_label}
        <div class="table">
          <p class="value"><span class="value-highlight">{fmt(extra_value)}</span></p>
          <p class="label">{extra_label}</p>
        </div>
      {/if}
    </div>
  </Tooltip>
{/if}

<style>
  .tooltip-content {
    padding: 10px;
    p.tooltip-heading {
      font-weight: var(--font-weight-bold);
      font-size: 14px;
      line-height: 150%;
      margin-bottom: 10px;
    }
  }
  span.state-label {
    color: white;
    font-weight: var(--font-weight-bold);
    background-color: var(--color-blue);
    padding: 3px 5px;
    letter-spacing: 1.4px;
    font-family: var(--font-family-sans-alt);
  }
  .table {
    display: flex;
    gap: 5px;
    p.label,
    p.value {
      font-size: 14px;
      line-height: 150%;
    }
    &:not(:first-of-type) {
      border-top: 1px solid var(--color-gray-shade-lighter);
      /* margin-top: 14px; */
      padding-top: 14px;
    }
  }
  span.value-highlight {
    font-size: 14px;
    font-weight: var(--font-weight-bold);
    font-family: var(--font-sans);
    background-color: var(--color-gray-shade-lighter);
    padding: 3px 5px;
    letter-spacing: normal;
  }
</style>
